import React from 'react';
import view from '@/public/svg/view-circle.svg';
import download from '@/public/svg/download.svg';

export type JobPdf = {
    title: string;
    filename: string;
    lines: string[];
};

type JobDownloadsProps = {
    jobs: JobPdf[];
};

const JobDownloads: React.FC<JobDownloadsProps> = ({ jobs }) => {
    if (jobs.length === 0) {
        return (
            <section className="w-full max-w-4xl mx-auto py-4 px-4">
                <p className="text-center text-textColor">Aktuell keine Stellen ausgeschrieben.</p>
            </section>
        );
    }

    return (
        <section className="w-full max-w-4xl mx-auto py-4 px-4">
            <div className="grid sm:grid-cols-2 gap-6">
                {jobs.map((job) => (
                    <div
                        key={job.filename}
                        className="bg-white shadow rounded-xl p-6 flex flex-col gap-4"
                    >
                        <h3 className="text-lg font-semibold text-textColor">{job.title}</h3>

                        <div className="flex flex-wrap gap-x-3 gap-y-2 text-sm text-textColor items-center">
                            {job.lines.map((line, index) => (
                                <React.Fragment key={index}>
                                    {index !== 0 && <span className="text-textColor">•</span>}
                                    <span>{line}</span>
                                </React.Fragment>
                            ))}
                        </div>

                        <div className="flex gap-4 mt-2">
                            <a
                                href={job.filename}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-primary font-medium hover:underline"
                            >
                                <img className="self-center h-5 w-5" src={view} alt={view} loading="lazy" />
                                PDF ansehen
                            </a>

                            <a
                                href={job.filename}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-primary font-medium hover:underline"
                            >
                                <img className="self-center h-5 w-5" src={download} alt={download} loading="lazy" />
                                PDF herunterladen
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>

    );
};

export default JobDownloads;
